import { useSrpContext } from '@/src/contexts'

import PopularAirlines from './popularAirlines'

const PopularAirlinesWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()

    const overview = sections?.airlines?.overview
    if (!overview) return null

    return (
        <PopularAirlines
            title={overview.title}
            summary={overview.summary}
        />
    )
}

export default PopularAirlinesWrapper
